<template>
    <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_511_227)">
            <path
                d="M68.3125 28.0273H2.6875C1.47891 28.0273 0.5 27.0484 0.5 25.8398V15.7227C0.5 14.5141 1.47891 13.5352 2.6875 13.5352H68.3125C69.5211 13.5352 70.5 14.5141 70.5 15.7227V25.8398C70.5 27.0484 69.5211 28.0273 68.3125 28.0273ZM4.875 23.6523H66.125V17.9102H4.875V23.6523Z"
                fill="#B5424A" />
            <path
                d="M64.2109 67.4023H6.78906C5.58047 67.4023 4.60156 66.4234 4.60156 65.2148V25.8398C4.60156 24.6312 5.58047 23.6523 6.78906 23.6523H64.2109C65.4195 23.6523 66.3984 24.6312 66.3984 25.8398V65.2148C66.3984 66.4234 65.4195 67.4023 64.2109 67.4023ZM8.97656 63.0273H62.0234V28.0273H8.97656V63.0273Z"
                fill="#B5424A" />
            <path
                d="M17.3164 41.6992C16.1078 41.6992 15.1289 40.7203 15.1289 39.5117V33.2227C15.1289 32.0141 16.1078 31.0352 17.3164 31.0352C18.525 31.0352 19.5039 32.0141 19.5039 33.2227V39.5117C19.5039 40.7203 18.525 41.6992 17.3164 41.6992Z"
                fill="#B5424A" />
            <path
                d="M20.4609 38.5547H14.1719C12.9633 38.5547 11.9844 37.5758 11.9844 36.3672C11.9844 35.1586 12.9633 34.1797 14.1719 34.1797H20.4609C21.6695 34.1797 22.6484 35.1586 22.6484 36.3672C22.6484 37.5758 21.6695 38.5547 20.4609 38.5547Z"
                fill="#B5424A" />
            <path
                d="M56.8281 38.5547H50.5391C49.3305 38.5547 48.3516 37.5758 48.3516 36.3672C48.3516 35.1586 49.3305 34.1797 50.5391 34.1797H56.8281C58.0367 34.1797 59.0156 35.1586 59.0156 36.3672C59.0156 37.5758 58.0367 38.5547 56.8281 38.5547Z"
                fill="#B5424A" />
            <path
                d="M34.1317 59.1992C32.409 59.1992 31.3276 57.2523 32.3229 55.784L35.7518 50.7213H31.1252C29.3739 50.7213 28.3307 48.758 29.3137 47.3074L35.0559 38.8308C35.734 37.83 37.0944 37.5689 38.0938 38.247C39.0946 38.9252 39.3557 40.2842 38.6776 41.2849L35.2487 46.3476H39.8752C41.6266 46.3476 42.6698 48.3109 41.6868 49.7615L35.9446 58.2381C35.5221 58.8629 34.8331 59.1992 34.1317 59.1992Z"
                fill="#B5424A" />
            <path
                d="M21.6914 17.9102H12.9414C11.7328 17.9102 10.7539 16.9312 10.7539 15.7227V8.33984C10.7539 7.13125 11.7328 6.15234 12.9414 6.15234H21.6914C22.9 6.15234 23.8789 7.13125 23.8789 8.33984V15.7227C23.8789 16.9312 22.9 17.9102 21.6914 17.9102ZM15.1289 13.5352H19.5039V10.5273H15.1289V13.5352Z"
                fill="#B5424A" />
            <path
                d="M17.3164 10.2539C16.1078 10.2539 15.1289 9.275 15.1289 8.06641V4.78516C15.1289 3.57656 16.1078 2.59766 17.3164 2.59766C18.525 2.59766 19.5039 3.57656 19.5039 4.78516V8.06641C19.5039 9.275 18.525 10.2539 17.3164 10.2539Z"
                fill="#B5424A" />
            <path
                d="M58.0586 17.9102H49.3086C48.1 17.9102 47.1211 16.9312 47.1211 15.7227V8.33984C47.1211 7.13125 48.1 6.15234 49.3086 6.15234H58.0586C59.2672 6.15234 60.2461 7.13125 60.2461 8.33984V15.7227C60.2461 16.9312 59.2672 17.9102 58.0586 17.9102ZM51.4961 13.5352H55.8711V10.5273H51.4961V13.5352Z"
                fill="#B5424A" />
            <g opacity="0.2">
                <path d="M68.3125 15.7227V25.8398H52.6309C56.0119 23.6879 57.9205 19.7791 57.4393 15.7227H68.3125Z"
                    fill="#B5424A" />
            </g>
            <g opacity="0.2">
                <path d="M64.2107 25.8398V65.2148H35.0732C49.1553 57.724 58.742 42.901 58.742 25.8398H64.2107Z"
                    fill="#B5424A" />
            </g>
            <g opacity="0.2">
                <path d="M58.0582 8.33984V15.7227H49.5557C52.9463 15.0186 55.2186 11.7729 54.7072 8.33984H58.0582Z"
                    fill="#B5424A" />
            </g>
            <g opacity="0.2">
                <path d="M21.691 8.33984V15.7227H13.1885C16.5791 15.0186 18.8514 11.7729 18.34 8.33984H21.691Z"
                    fill="#B5424A" />
            </g>
            <path
                d="M53.6836 10.2539C52.475 10.2539 51.4961 9.275 51.4961 8.06641V4.78516C51.4961 3.57656 52.475 2.59766 53.6836 2.59766C54.8922 2.59766 55.8711 3.57656 55.8711 4.78516V8.06641C55.8711 9.275 54.8922 10.2539 53.6836 10.2539Z"
                fill="#B5424A" />
        </g>
        <defs>
            <clipPath id="clip0_511_227">
                <rect width="70" height="70" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
</template>